import dayjs from "dayjs";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { ReprintAuthRow } from "../../types/reprintAuth.type";
import { isNearExpiry, isOverPrint, CHARCOAL } from "./data";

export type SummaryCardKey = "active" | "near_expiry" | "over_print" | "today";

interface SummaryCardsProps {
  // Active-grant sample used to derive the advisory counts.
  activeSample: ReprintAuthRow[];
  activeCount: number;
  onSelect: (key: SummaryCardKey) => void;
}

interface CardDef {
  key: SummaryCardKey;
  label: string;
  value: number;
  color: string;
}

export default function SummaryCards({
  activeSample,
  activeCount,
  onSelect,
}: SummaryCardsProps) {
  const nearExpiryCount = activeSample.filter(isNearExpiry).length;
  const overPrintCount = activeSample.filter(isOverPrint).length;
  // Reprints "today" — summed over active grants created today (advisory).
  const todayReprintCount = activeSample
    .filter((r) => dayjs(r.created_at).isSame(dayjs(), "day"))
    .reduce((sum, r) => sum + (r.reprint_count || 0), 0);

  const cards: CardDef[] = [
    { key: "active", label: "ใช้งานได้", value: activeCount, color: "#45be77" },
    {
      key: "near_expiry",
      label: "ใกล้หมดอายุ (<3 ชม.)",
      value: nearExpiryCount,
      color: "#FDA42C",
    },
    {
      key: "over_print",
      label: "เฝ้าระวัง · พิมพ์ซ้ำเกินกำหนด",
      value: overPrintCount,
      color: "#fb3b3b",
    },
    {
      key: "today",
      label: "พิมพ์ซ้ำวันนี้",
      value: todayReprintCount,
      color: CHARCOAL,
    },
  ];

  return (
    <Grid container spacing={2} mb={2}>
      {cards.map((card) => (
        <Grid key={card.key} size={{ xs: 6, sm: 3 }}>
          <Paper
            onClick={() => onSelect(card.key)}
            sx={{
              cursor: "pointer",
              borderLeft: `4px solid ${card.color}`,
              transition: "box-shadow 0.15s",
              "&:hover": { boxShadow: 3 },
            }}
          >
            <Typography variant="h4" sx={{ fontWeight: 700, color: card.color }}>
              {card.value}
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              {card.label}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
